import { BASE_URL } from '@/utils/constants/api-constants';
import axios, { AxiosInstance } from 'axios';

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $axios: AxiosInstance;
    $api: AxiosInstance;
  }
}

const usersApi = axios.create({ baseURL: BASE_URL.USERS });

export { usersApi };
